import React, { useRef, useEffect, useContext } from 'react';
import {
  components,
  OptionTypeBase,
  Props as SelectProps,
  GroupTypeBase,
  OptionProps,
} from 'react-select';
import { useField } from '@unform/core';

import {
  customStyles,
  Container,
  SelectComponent,
  OptionContent,
  OptionThree,
  ErrorMessage,
} from './styles';

import { ThemeContext } from 'styled-components';
import Avatar from 'components/Avatar';

interface IOptionProps
  extends OptionProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>> {}
interface Props extends Omit<SelectProps<OptionTypeBase>, 'theme'> {
  name: string;
  placeholder: string;
  searchable?: boolean;
  disabled?: boolean;
  errorField?: string;
  type?: 'avatar' | 'default' | 'threeOptions';
}
const Select: React.FC<Props> = ({
  name,
  disabled,
  searchable,
  type = 'default',
  ...rest
}: Props) => {
  const selectRef = useRef(null);
  const themeContext = useContext(ThemeContext);

  const { fieldName, defaultValue, registerField, error } = useField(name);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      setValue: (ref, value) => {
        ref.select.setValue(value);
        // ref.state.value = value;
      },
      getValue: (ref: any) => {
        if (rest.isMulti) {
          if (!ref.state.value) {
            return [];
          }
          return ref.state.value.map((option: OptionTypeBase) => option.value);
        }
        if (!ref.state.value) {
          return undefined;
        }
        return ref.state.value.value;
      },
      clearValue: ref => {
        ref.select.clearValue();
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  const optionDefault = (props: IOptionProps) => {
    return <components.Option {...props} />;
    // return <components.Option {...props}>{children}</components.Option>;
  };

  const OptionAvatar = (props: IOptionProps) => {
    return (
      <OptionContent>
        <Avatar
          size="36"
          name={props.data.label}
          src={props.data.avatar_url}
          round
          alt={props.data.label}
        />

        <components.Option {...props} />
      </OptionContent>
    );
  };

  const OptionThreeLabel = ({ ...rest }: IOptionProps) => {
    const { innerProps, innerRef } = rest;
    return (
      <OptionThree ref={innerRef} {...innerProps}>
        <p>{rest.data.label}</p>
        {rest.data.sublabel ? <span>({rest.data.sublabel})</span> : ''}
      </OptionThree>
    );
  };

  const customOption = {
    default: optionDefault,
    threeOptions: OptionThreeLabel,
    avatar: OptionAvatar,
  };
  return (
    <Container error={rest.errorField} disabled={disabled}>
      {themeContext && (
        <SelectComponent
          error={error}
          defaultValue={defaultValue}
          ref={selectRef}
          styles={customStyles(themeContext)}
          isSearchable={searchable}
          isDisabled={disabled}
          noOption="Nenhuma opção"
          isMulti={rest.isMulti}
          classNamePrefix="react-select"
          components={{ Option: customOption[type] }}
          {...rest}
        />
      )}
      {!!rest.errorField ||
        (!!error && <ErrorMessage>{error || rest.errorField}</ErrorMessage>)}
    </Container>
  );
};

export default Select;
